// :cow: Cosmose CONFIDENTIAL :iso:
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, STATE_NAME } from '@coa/app/shared/add-to-group-dialog/modules/create-group/store/create-group.reducer';

const currentState = createFeatureSelector<State>(STATE_NAME);

export const selectIsLoading = createSelector(
  currentState,
  (state: State) => state.isLoading,
);

export const selectShowError = createSelector(
  currentState,
  (state: State) => state.isError,
);
